import PromotionCard from "../PromotionCard";
import MarketingCard from "../MarketingCard/MarketingCard";
import useIsMarketingBannersEnabled from "../MarketingImage/hooks";
import useWelcomeOffer from "./useWelcomeOffer";

const MarketingCardContainer = () => {
  const welcomeOffer = useWelcomeOffer();
  const isMarketingBannersEnabled = useIsMarketingBannersEnabled();

  if (welcomeOffer && !isMarketingBannersEnabled) {
    return <PromotionCard promotion={welcomeOffer} />;
  } else if (isMarketingBannersEnabled) {
    return <MarketingCard address="31b65103-a70b-4a35-8245-124a91fe1fe0" />;
  }

  return null;
};

export default MarketingCardContainer;
